import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    checkUrl: String,
    maxChecks: { type: Number, default: 30 },
    interval: { type: Number, default: 2000 },
  };

  initialize() {
    this.checkCount = 0;
  }

  connect() {
    this.url = this.element.dataset.partyPlanCheckUrlValue;
    this.checkCount = 0;
    if (this.url) {
      this.startChecking();
    } else {
      // No check URL provided
    }
  }

  disconnect() {
    this.stopChecking();
  }

  startChecking() {
    this.timer = setTimeout(() => {
      this.checkPartyPlanStatus();
    }, this.intervalValue);
  }

  stopChecking() {
    this.checkCount = 0;
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  async checkPartyPlanStatus() {
    if (this.checkCount >= this.maxChecksValue) {
      this.stopChecking();
      return;
    }

    try {
      const response = await fetch(this.url, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.party_plan) {
          // Party plan is ready, reload the page
          window.location.reload();
          return;
        }
      }
    } catch (error) {
      this.stopChecking();
      return;
    }

    this.checkCount++;

    this.timer = setTimeout(() => {
      this.checkPartyPlanStatus();
    }, this.intervalValue);
  }
}
